import React, {useEffect, useState} from 'react';
// import loadLandbot from '../lib/loadLandbot';
import addIntercom from '../lib/addIntercom';
import Loader from '../Components/Loader';
import isSiteBuilder from '../lib/isSiteBuilder';
import BackgroundPhoto from '../Components/BackgroundPhoto';

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export default function Rejection({ history }) {
  document.title = "Onboarding";

  const [rejection_reason, setRejection_reason] = useState(null);
  const [loading, setLoading] = useState(true);
  const [programName, setProgramName] = useState(null);
  const [email, setEmail] = useState(null);
  const [failedCheck, setFailedCheck] = useState(null);

  useEffect(() => {
    if (isSiteBuilder()) {
      setTimeout(() => {
        setRejection_reason("failed person check");
        setProgramName("Orenda");
        setEmail("info@orenda.finance");
      }, 2000);
      return;
    }
  
    window.OrendaGetResponse({ event_name: "page load - rejection" }, response => {
      setRejection_reason(response.account_details.rejection_reason);
      addIntercom(response.Intercom, response.kycData.full_name, response.person_details.current_email, response.person_details.current_AccountId, response.account_details.account_type, false);
    }, false);
    // window.OrendaGetResponse({ event_name: "getChatbot - rejection" }, ({chatbot_url}) => setUrl(chatbot_url), false);
    window.OrendaGetResponse({ event_name: "page load 1 - rejection" }, x => {
      setProgramName(x.program.shortName);
      setEmail(x.program.contact);
    }, false);
    return;
  }, []);

  useEffect(() => {
    if(!rejection_reason || !programName) return;
    if(rejection_reason === "not over 18") setFailedCheck("over 18 age");
    if(rejection_reason === "failed business check") setFailedCheck("business");
    if(rejection_reason === "failed person check") setFailedCheck("person");
    setLoading(false);
  }, [rejection_reason, email, programName]);

  if (loading) return <Loader />;

  if(rejection_reason === "failed business check"){
    return (
      <BackgroundPhoto>
        <h5>Please allow up to 48 hours for completion of KYB.</h5>
        <h5>You will be contacted via email once the process is complete.</h5>
      </BackgroundPhoto>
    );
  }

  return (
    <BackgroundPhoto>
      <h5>{`Unfortunately you haven't passed our ${failedCheck} check.`}</h5>
      <h5>{failedCheck === "not over 18" ? "Unfortunately under 18s aren't eligible" : `If you would like to know more, email us ${email}.`}</h5>
      <h5>{`We wish you all the best and thank you for applying to ${programName}.`}</h5>
    </BackgroundPhoto>
  );
}
